import { Box } from "@chakra-ui/react";

import {
  ColorIcon,
  colors,
  customEvent,
  HStack,
  NextLink,
  VStack,
  SlidingMenu,
  Image,
  getCdnImageSrc,
  FUNERAL_SIDO,
  VLine,

  // call,
} from "goi_common";
import { useState } from "react";
import CareFeeSection from "./components/CareFeeSection";
import CareInformationSection from "./components/CareInformationSection";
import CareReviewSection from "./components/CareReviewSection";

import MainInfoSection from "./components/MainInfoSection";

function CareDetailContainer({ care }: { care: any }) {
  const [current, setCurrent] = useState<number>(0);

  const excludeCare = [3980];
  const isExcludeCare = excludeCare.includes(care.id);

  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth="480px" margin="0 0 60px">
        <HStack
          width="100%"
          height="50px"
          justifyContent="center"
          alignItems="center"
          position="relative"
        >
          <Box position="absolute" left="10px">
            <a
              target="_self"
              href={
                care.sido
                  ? `/care/region/${FUNERAL_SIDO.get(care.sido)}/`
                  : "https://prime.goifuneral.co.kr"
              }
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "care_detail",
                    trigger_and_target: "back-uv_hsps_serch",
                  },
                });
              }}
            >
              <ColorIcon
                name="thinArrow"
                css={{ transform: "rotateZ(180deg)" }}
                size={30}
                color={colors.gray700}
              />
            </a>
          </Box>
          <div className="button">{care.companyname}</div>
        </HStack>
        <MainInfoSection name={care.companyname} care={care} />

        <SlidingMenu
          current={current}
          setCurrent={(v) => {
            customEvent({
              newGtm: {
                path: "care_detail",
                trigger_and_target:
                  current === 0
                    ? "tab-info_tab"
                    : current === 1
                    ? "tab-review_tab"
                    : "",
              },
            });
            setCurrent(v);
          }}
          items={["기본 정보", `후기`]}
        />

        <VStack>
          <NextLink
            href="https://prime.goifuneral.co.kr/?utm_campaign=nursing_hospital"
            event={{
              newGtm: {
                path: "care_detail",
                trigger_and_target: "uv_prime",
              },
            }}
          >
            <Image
              src={getCdnImageSrc("direct/100_banner_2.png")}
              alt=""
              width="100%"
            />
          </NextLink>
        </VStack>
        {!isExcludeCare ? (
          <>
            {current === 0 && (
              <>
                <CareInformationSection care={care} />
                <VLine width="100%" height="1px" color={colors.gray300} />
                <CareCTASection />

                <VLine width="100%" height="1px" color={colors.gray300} />
                <CareFeeSection care={care} />
              </>
            )}

            {current === 1 && <CareReviewSection />}
          </>
        ) : (
          <>
            <Box
              className="subtitle_16_sb gray700"
              padding="80px 6px"
              textAlign="center"
            >
              해당 요양시설의 요청에 의해
              <br />
              가격, 비용정보, 후기, 사진 등의 정보를 제공하지 않습니다.
            </Box>
            <VLine width="100%" height="1px" color={colors.gray300} />
            <CareCTASection />
          </>
        )}
      </VStack>
    </VStack>
  );
}
export default CareDetailContainer;

function CareCTASection() {
  return (
    <VStack
      className="body_14_m"
      alignItems="center"
      gap="8px"
      padding="40px 0"
    >
      <p className="subtitle_18_b" css={{ textAlign: "center" }}>
        요양시설 선택 시 고려사항이 궁금하신가요?
      </p>
      <p css={{ textAlign: "center" }}>요양시설 체크리스트 확인하시고,</p>
      <p css={{ textAlign: "center" }}>
        부모님을 위한 최고의 요양시설을 선택하세요.
      </p>
      <VStack alignItems="center" padding="10px 0 0">
        <NextLink
          href="https://prime.goifuneral.co.kr/content/feeds/care-center/?utm_campaign=care_cta"
          event={{
            newGtm: { path: "care_detail", trigger_and_target: "CTA" },
          }}
        >
          <HStack
            gap={10}
            background={colors.gray900}
            padding="16px 30px"
            justifyContent="center"
            borderRadius="6px"
          >
            <span className="button_14_sb white">
              요양시설 체크리스트 확인하기
            </span>
            <ColorIcon
              name="icon-arrow-right-circle-mono"
              color={colors.white}
              size={16}
            />
          </HStack>
        </NextLink>
      </VStack>
    </VStack>
  );
}
